export default __webpack_public_path__ + "static/media/constellation_6.f3adae7d.png";